import { render, staticRenderFns } from "./OtherProjects.vue?vue&type=template&id=7ea31bb2&scoped=true&"
import script from "./OtherProjects.vue?vue&type=script&lang=ts&"
export * from "./OtherProjects.vue?vue&type=script&lang=ts&"
import style0 from "./OtherProjects.vue?vue&type=style&index=0&id=7ea31bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea31bb2",
  null
  
)

export default component.exports